import { render, staticRenderFns } from "./UserRequests.vue?vue&type=template&id=137c5346&scoped=true"
import script from "./UserRequests.vue?vue&type=script&lang=js"
export * from "./UserRequests.vue?vue&type=script&lang=js"
import style0 from "./UserRequests.vue?vue&type=style&index=0&id=137c5346&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "137c5346",
  null
  
)

export default component.exports